import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const moduleSceneSetup = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    loadedModelName: "",
    modelBySize: "",
    defaultSize: "9.0",
    default_textures: {},
    shaders: {}
  }
};

export default moduleSceneSetup;
